import React, { useState, useEffect, useRef } from "react";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import { mediaUrl, baseURL } from "../../axiosInterceptor/axiosInterceptorC";
import OwlCarousel from "react-owl-carousel3";

const path = "/keralaplots/";

function HomeBuilder() {
  const [isLoading, setIsLoading] = useState(true);
  const [websiteDetails, setWebsiteDetails] = useState([]);
  const carouselRef = useRef(null); // Reference for carousel

  useEffect(() => {
    fetchWebsiteDetails();
  }, []);

  const fetchWebsiteDetails = async () => {
    const login_id = localStorage.getItem("login_id");
    try {
      const response = await axios.post(`${baseURL}/website/fetchwebsitedetails`, {
        login_id: login_id,
      });

      if (response.data && response.data.length > 0) {
        setWebsiteDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching website details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const settings = {
    dots: false,
    loop: true,
    nav: false,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 2 },
      1200: { items: 2 },
    },
  };

  // Custom Next & Prev Handlers
  const goToNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const goToPrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  return (
    <section id="homeBuilder">
      <div className="container">
        <div className="homeBuilderHead">
          <h2 className="title">Explore Trusted Builders in Kerala</h2>
          <p>
            Discover a curated list of trusted builders in Kerala. Explore their
            projects, expertise, and offerings to find the perfect partner for your
            dream property.
          </p>
        </div>

        <div className="homeBuilderMain">
          {isLoading ? (
            <div className="SkeletonLoader">
              {[...Array(2)].map((_, index) => (
                <div key={index} className="SkeletonLoaderBox">
                  <div className="SkeletonLoaderBoxCol1">
                    <Skeleton />
                  </div>
                  <div className="SkeletonLoaderBoxCol2">
                    <div className="SkeletonLoaderBoxCol2Logo">
                      <Skeleton />
                    </div>
                    <div className="SkeletonLoaderBoxCol2Name">
                      <Skeleton />
                      <Skeleton />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : websiteDetails.length > 0 ? (
            <div className="carouselWrapper">
                {/* Custom Prev Button */}
                <button className="customNavBtn prev" onClick={goToPrev}>
                    <GoChevronLeft />
                </button>
                <OwlCarousel {...settings} ref={carouselRef}>
                {websiteDetails.map((builder, index) => (
                    <a
                    key={index}
                    href={`${path}${builder.company_name}`}
                    target="_blank"
                    className="homeBuilderBox"
                    onClick={() => localStorage.setItem("companyName", builder.company_name)}
                    >
                    <div className="homeBuilderBoxThumbnail">
                        <img src={mediaUrl + builder.image} alt={builder.company_name} />
                    </div>
                    <div className="homeBuilderBoxDetails">
                        <div className="homeBuilderBoxDetailsCol1">
                        <div className="homeBuilderBoxProfileImg">
                            <img src={mediaUrl + builder.logo_image} alt="Builder Logo" />
                        </div>
                        <div className="homeBuilderBoxProfileName">
                            <h3>{builder.company_name}</h3>
                            <div className="homeBuilderBoxProfileNameStrip">
                            <div className="exp">
                                <h4>{builder.experience_val}</h4>
                                <p>Experience</p>
                            </div>
                            <div className="propertyCount">
                                <h4>{builder.total_properties}</h4>
                                <p>Properties</p>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </a>
                ))}
                </OwlCarousel>

                {/* Custom Next Button */}
                <button className="customNavBtn next" onClick={goToNext}>
                <GoChevronRight />
                </button>
            </div>
          ) : (
            <p className="no-data-message">No builders found</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default HomeBuilder;
